// Owner-specific accent colours, reused across H2H cards and chart lines so
// the visual identity of each player is consistent everywhere.

export const ownerColor: Record<string, string> = {
  Askari: "#dc2626", // red
  Nour: "#16a34a", // green
  Murray: "#2563eb", // blue
  Elliot: "#9333ea", // purple
  Rachel: "#ea580c", // orange
  Heja: "#0891b2", // cyan
};

export function colorForOwner(owner: string | null | undefined): string {
  if (!owner) return "#0f172a";
  return ownerColor[owner] ?? "#0f172a";
}
